import * as API from '..'
export default {
  //企业信息列表接口
  enterpriseList: params => {
    return API.POST(process.env.baseSysURL + '/enterprise/list', params)
  },
  //查询主体类型接口
  dicTypeList: params => {
    return API.POST(process.env.baseSysURL + '/dic/enterprise/type/list', params)
  },
  //查询所属行业接口
  industryTypeList: params => {
    return API.POST(process.env.baseSysURL + '/dic/industry/type/list', params)
  },
  //查询所属行业接口
  enterpriseCheck: params => {
    return API.POST(process.env.baseSysURL + '/enterprise/check', params)
  },
  //查询所属行业接口
  enterpriseDetail: params => {
    return API.POST(process.env.baseSysURL + '/enterprise/detail', params)
  },


  //查询名录库管理列表接口
  priseList: params => {
    return API.POST(process.env.serverV1 + '/njbenterprise/list', params)
  },
  //查询名录库管理详情接口
  priseDetail: params => {
    return API.POST(process.env.serverV1 + '/njbenterprise/detail', params)
  },
  //名录库管理详情保存接口
  enterpriseSave: params => {
    return API.POST(process.env.serverV1 + '/njbenterprise/save', params)
  },
  //查询所属行业接口
  commonList: params => {
    return API.GET(process.env.serverV1 + '/dic/common/list', params)
  },
  //查询所属行业接口
  managementTypeList: params => {
    return API.GET(process.env.serverV1 + '/dic/managementType/list', params)
  },
  //规范化管理列表接口
  manageList: params => {
    return API.POST(process.env.serverV1 + '/njbenterprise/manage/list', params)
  },
  //规范化管理年度上报详情接口
  manageDetail: params => {
    return API.POST(process.env.serverV1 + '/njbenterprise/manage/detail', params)
  },
  //规范化其他信息接口
  restDetail: params => {
    return API.POST(process.env.serverV1 + '/njbenterprise/rest/detail', params)
  },
  /**
   * 示范社列表查询
   * @param {
   * } params
   * @returns
   */
  demonstrationSocietyList: params => {
    // return API.POST('http://172.16.0.194:8849/gss-manage-server-api/api/v1/web/demonstration/society/list',params)
    return API.POST(process.env.serverV2 + '/web/demonstration/society/list', params)

  },
  /**
   * 示范社通过驳回接口
   * @param {*} params
   * @returns
   */
  demonstrationSocietyUpdateStatus: params => {
    // return API.POST('http://172.16.0.194:8849/gss-manage-server-api/api/v1/web/demonstration/society/update/status',params)
    return API.POST(process.env.serverV2 + '/web/demonstration/society/update/status', params)
  },
  /**
   * 主体名录。异常、注销、驳回
   * @param {*} params
   * @returns
   */
  njbenterpriseUpdate: params => {
    // return API.POST('http://172.16.0.194:8849/gss-sys-server-api/api/v1/njbenterprise/update',params)
    return API.POST(process.env.serverV1 + '/njbenterprise/update', params)
  },
  /**
   * 合作社成员统计
   * @param {*} params
   * @returns
   */
  enterpriseStatMembers: params => {
    // return API.POST('http://172.16.0.194:8849/gss-sys-server-api/api/v1/enterprise/stat/members',params)
    return API.POST(process.env.serverV1 + '/enterprise/stat/members', params)
  },
  /**
   *  经营类型统计
   * @param {*} params
   * @returns
   */
  enterpriseStatType: params => {
    // return API.POST('http://172.16.0.194:8849/gss-sys-server-api/api/v1/enterprise/stat/type',params)
    return API.POST(process.env.serverV1 + '/enterprise/stat/type', params)
  },
  /**
   * 主体信息统计
   * @param {*} params
   * @returns
   */
  enterpriseStatEnterpriseCount: params => {
    // return API.POST('http://172.16.0.194:8849/gss-sys-server-api/api/v1/enterprise/stat/type',params)
    return API.POST(process.env.serverV1 + '/enterprise/stat/enterprise/count', params)
  },
  /**
   * 企业示范等级统计数据
   * @param {*} params
   * @returns
   */
  enterpriseStatGrade: params => {
    // return API.POST('http://172.16.0.194:8849/gss-sys-server-api/api/v1/enterprise/stat/type',params)
    return API.POST(process.env.serverV1 + '/enterprise/stat/grade', params)
  },
  /**
   * 企业待办统计数据
   * @param {*} params
   * @returns
   */
  enterpriseStatWaitCount: params => {

    return API.POST(process.env.serverV1 + '/enterprise/stat/wait/count', params)
  },
  enterpriseStatEnterpriseType: params => {

    return API.POST(process.env.serverV1 + '/enterprise/stat/enterprise/type', params)
  },
  //经营类型
  industryTree: params => {

    return API.GET(process.env.baseSyst2URL+'/dic/industry/tree', params)
  },
  //主体类型http://120.133.60.156:8849/gss-sys-server-api/api/v1/dic/common/list?code=3
  commonList: params => {

    return API.GET(process.env.baseSysURL+'/dic/common/list', params)
  },
  // 新型经营主体
  statIndustry: params => {

    return API.POST(process.env.baseSysURL+'/enterprise/stat/industry', params)
  },

  //审核通过驳回按钮
  enterpriseCheck: params => {
    // return API.POST('http://120.133.60.156:8849/gss-sys-server-api/api/v1/enterprise/stat/industry',params)
    return API.POST(process.env.serverV3+'/enterprise/check', params)
  },
  //审核日志
  enterpriseLogList: params => {

    return API.POST(process.env.baseSysURL+'/enterprise/log/list', params)
  },
  //示范企业上报列表http://120.133.60.156:8849/gss-manage-server-api/api/v1//manage/report/list
  managereportList: params => {
    return API.POST(process.env.serverV2 + '/manage/report/list', params)
  },
  //示范申请详情接口http://120.133.60.156:8849/gss-sys-server-api/api/v2/demonstration/detail
  demonstrationDetail: params => {
    return API.POST(process.env.baseSyst2URL+'/demonstration/detail', params)
  },
  //示范日志
  demonstrateList: params => {
    return API.POST(process.env.baseSysURL+'/enterprise/log/demonstrate/list', params)
  },
  //示范社审核http://120.133.60.156:8849/
  demonstrationCheck: params => {
    return API.POST(process.env.baseSyst2URL+'/demonstration/check', params)
  },
  // 取消示范社评级http://120.133.60.156:8849/
  demonstrationCancel: params => {
    return API.POST(process.env.baseSyst2URL+'/demonstration/cancel', params)
  },
  // 示范列表接口http://120.133.60.156:8849/gss-sys-server-api/api/v2/demonstration/list
  demonstrationList: params => {
    return API.POST(process.env.baseSyst2URL+'/demonstration/list', params)
  },
  //主体类型
  commonListApp: params => {
    return API.POST(process.env.baseSysURL+'/dic/app/list', params)
  },

  screenDetail:params=>{
    return API.POST(process.env.nj_server+'/index/detail',params)
  },

  libraryList: params=>{
    return API.POST(process.env.serverV3+'/enterprise/list',params)
  },

  reviewedList: params=>{
    return API.POST(process.env.serverV3+'/enterprise/check-list',params)
  },

  revokeRow: params=>{
    return API.POST(process.env.serverV3+'/enterprise/revoke',params)
  },
}




// WEBPACK FOOTER //
// ./src/api/serviceOrgManagement/api_userManagement.js